__turbopack_context__.v({
  "wrp": "contentWrp-module-scss-module__vbiqRa__wrp",
  "wrpOverflowFix": "contentWrp-module-scss-module__vbiqRa__wrpOverflowFix",
});
